import { api } from '@/lib/axios';

// API returns camelCase — field names match the C# record serialisation.
export interface ContentParagraph {
  paragraphConfigCode: string;
  text: string;
  langReturned: string;
}

export interface AppLanguage {
  appLanguageCode: string;
  description: string;
  activeFlag: string;
  ppVisibleFlag: string;
  /** l_app_language.display_order. Missing values sort after numbered rows. */
  displayOrder?: number;
}

export const contentService = {
  getParagraphs: async (lang: string): Promise<ContentParagraph[]> => {
    try {
      const res = await api.get<ContentParagraph[]>('/Content/Paragraphs', {
        params: { lang },
      });
      return res.data;
    } catch {
      return [];
    }
  },

  // Called only when a code was absent from the bulk load.
  // Returns null on 404 (unregistered code) — caller falls back to t().
  getParagraphByCode: async (code: string): Promise<ContentParagraph | null> => {
    try {
      const res = await api.get<ContentParagraph>(
        `/Content/Paragraph/${encodeURIComponent(code)}`,
      );
      return res.data;
    } catch {
      return null;
    }
  },

  getLanguages: async (): Promise<AppLanguage[]> => {
    try {
      const res = await api.get<AppLanguage[]>('/Content/Languages');
      return res.data;
    } catch {
      return [];
    }
  },
};
